import React from 'react';
import aboutMeImg from '../../assets/images/client_feeback_img.jpg';
import { Container, Eyebrow, PillButton } from './ui';

const card = 'rounded-2xl bg-[#f4f6fa] p-5 sm:p-6';

const StatCard = ({ label, value }) => (
  <div className={`${card} flex items-center justify-between gap-4`}>
    <span className="text-[13px] leading-snug text-[#111]/70 whitespace-pre-line">{label}</span>
    <span className="text-3xl font-medium tracking-tight text-[#111]">
      {value}
    </span>
  </div>
);

const strengths = [
  { label: 'Custom Software Development', className: 'left-0 top-0' },
  { label: 'Mobile Apps', className: 'left-0 top-[34px] text-[#111]' },
  { label: 'ERP & Automation', className: 'left-0 top-[68px]' },
];

const AboutMe = () => (
  <section id="about" className="bg-[#e9ecf2] py-20 lg:py-28">
    <Container>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10">
        <div className="lg:col-span-4">
          <Eyebrow>About Me</Eyebrow>
        </div>
        <div className="lg:col-span-8">
          <p className="text-[28px] sm:text-[36px] lg:text-[40px] font-medium leading-[1.12] tracking-[-0.035em] text-[#111]">
            I build reliable software that connects clean architecture, great usability, and real business results.
          </p>
          <PillButton to="/contact" className="mt-8">
            Get In Touch
          </PillButton>
        </div>
      </div>

      <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-end">
        {/* Workspace photo filling the framed card (wide photo, tall card: crop centred on the code) */}
        <div className="lg:col-span-4">
          <div className="relative aspect-[4/5] max-w-[360px] lg:max-w-none mx-auto lg:mx-0 rounded-3xl overflow-hidden border-[6px] border-[#f4f6fa] bg-[#1b1d22] shadow-[0_24px_50px_rgba(17,24,58,0.18)]">
            <img
              src={aboutMeImg}
              alt="Code editor open on a laptop under blue light"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover object-[52%_50%]"
            />
          </div>
        </div>

        <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
          <StatCard label={'Years\nExperience'} value="7+" />
          <StatCard label={'Successful Client\nPartnerships'} value="24+" />

          <div className={`${card} relative min-h-[190px] overflow-hidden`}>
            <p className="text-2xl font-medium tracking-tight text-[#111]">
              43+
            </p>
            <p className="text-[13px] text-[#111]/70 mt-1">Projects Shipped to Production</p>
          </div>

          <div className={`${card} relative min-h-[190px] overflow-hidden`}>
            <p className="text-xl font-medium leading-tight tracking-tight text-[#111]">
              Clean Architecture,
              <br />
              Fast Delivery
            </p>
            <div className="relative mt-6 h-[100px]">
              {strengths.map((s) => (
                <span
                  key={s.label}
                  className={`absolute bg-[#e6e9f0] rounded-full px-3.5 py-1 text-xs text-[#111]/70 ${s.className}`}
                >
                  {s.label}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Container>
  </section>
);

export default AboutMe;
